module.exports = __webpack_public_path__ + "static/media/mc_lid_open.6ae767c5.svg";